import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"max-width":"70%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_ScopeManager = _resolveComponent("ScopeManager")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_UploadDocument = _resolveComponent("UploadDocument")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: "",
    class: "pb-0 mb-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "default_card large mx-0 my-2 pa-2 fill-height sticky-card",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "8" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_back, {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.go(-1)), ["stop"]))
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex align-center justify-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    rounded: "pill",
                    block: "",
                    disabled: _ctx.isDisabled,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.upload()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.patternId ? "Modifier" : "Créer"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.profile.configuration.accountingRule.read)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            class: "default_card_admin"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                cols: "8",
                class: "mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex justify-start align-center"
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createElementVNode("h2", null, "Nom de l'export", -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "title px-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        placeholder: "Nom",
                        "hide-details": true,
                        modelValue: _ctx.exportName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.exportName) = $event)),
                        outlined: "",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.format === 'xlsx')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "mt-4 mb-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-start align-center"
                        }, {
                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createElementVNode("h2", null, "Exports", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exportList, (exportItem, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "py-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: _ctx.exportList[index].selected,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.exportList[index].selected) = $event),
                                  label: exportItem.text,
                                  density: "compact",
                                  "hide-details": ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        (_ctx.exportList[index].selected)
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 0,
                              "no-gutters": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "4",
                                  class: "px-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      modelValue: 
                                    _ctx.exportList[index].position
                                        .worksheet
                                ,
                                      "onUpdate:modelValue": ($event: any) => ((
                                    _ctx.exportList[index].position
                                        .worksheet
                                ) = $event),
                                      label: "Nom de la feuille",
                                      outlined: "",
                                      "hide-details": "",
                                      density: "compact"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, {
                                  cols: "4",
                                  class: "px-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_oss_text_field_filled, {
                                      modelValue: 
                                    _ctx.exportList[index].position
                                        .startRow
                                ,
                                      "onUpdate:modelValue": ($event: any) => ((
                                    _ctx.exportList[index].position
                                        .startRow
                                ) = $event),
                                      label: "Ligne de départ",
                                      "hide-details": ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, {
                                  cols: "4",
                                  class: "px-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      modelValue: 
                                    _ctx.exportList[index].position
                                        .startColumn
                                ,
                                      "onUpdate:modelValue": ($event: any) => ((
                                    _ctx.exportList[index].position
                                        .startColumn
                                ) = $event),
                                      label: "Colonne de départ",
                                      outlined: "",
                                      "hide-details": "",
                                      density: "compact"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                (index !== _ctx.exportList.length - 1)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "12",
                                      class: "py-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_divider)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 256)),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "d-flex justify-center pt-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_divider)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "my-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex justify-start align-center"
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createElementVNode("h2", null, "Fichier", -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "title px-1 pt-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        placeholder: "Joindre un fichier",
                        "hide-details": true,
                        outlined: "",
                        readonly: "",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (
                            !_ctx.readonly
                                ? (_ctx.dialogUploadDocument = true)
                                : ''
                        ), ["stop"])),
                        "model-value": _ctx.filename,
                        density: "compact"
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createVNode(_component_ScopeManager, {
          modelValue: _ctx.scopeSync,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.scopeSync) = $event)),
          id: _ctx.scopeId,
          "onUpdate:id": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.scopeId) = $event)),
          name: _ctx.scopeName,
          "onUpdate:name": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.scopeName) = $event)),
          readonly: _ctx.readonly
        }, null, 8, ["modelValue", "id", "name", "readonly"]),
        _createVNode(_component_v_snackbar, {
          modelValue: _ctx.snackbarActive,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.snackbarActive) = $event))
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.snackbarActive = false)),
              variant: "text"
            }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createTextVNode(" Close ")
              ])),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.snackbarText) + " ", 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogUploadDocument,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dialogUploadDocument) = $event)),
        title: "Importer un fichier"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_UploadDocument, {
              showFirstPrevious: false,
              companyId: _ctx.accountingCompanyId,
              documentType: "EXPORT_OFFICE",
              multiple: false,
              freeTag: false,
              showBtns: true,
              inExtensions: 
                        _ctx.format === 'xlsx' ? ['xlsx', 'xls', 'xlsm'] : ['docx', 'doc']
                    ,
              onFile: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addPersonalisedDoc($event)))
            }, null, 8, ["companyId", "inExtensions"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}